import { useRouter } from 'next/router';
import React from 'react';

import { MmbApiSectionProvider } from '@/api';
import { useActiveBrandConfig } from '@/brand';
import { OnlyDesktop } from '@/common';
import Footer from '@/hox-core/components/Footer.component';
import { useTranslation } from '@/i18n';
import { FullScreenLayout, Header, HeaderNav } from '@/ui/layout';
import { Spacer } from '@/ui/spacing';
import { WizardStep } from '@/ui/wizard';

interface BookingManagementPageLayoutProps {
  children: React.ReactNode;
}

export const BookingManagementPageLayout: React.FC<
  BookingManagementPageLayoutProps
> = (props) => {
  const { t } = useTranslation('bookingManagement');

  const { hideLanguageAndCurrencySelectorInBookingManagement } =
    useActiveBrandConfig();

  const router = useRouter();

  return (
    <MmbApiSectionProvider>
      <div>
        <Header
          hideLanguageAndCurrencySelector={
            hideLanguageAndCurrencySelectorInBookingManagement
          }
        >
          <HeaderNav>
            <WizardStep
              onClick={() => {
                void router.push('/account/login');
              }}
              title={t('amendBookingRequest.headerTitle')}
              isActive
            />
          </HeaderNav>
        </Header>
        <FullScreenLayout>
          <OnlyDesktop>
            <Spacer s="xl" />
          </OnlyDesktop>
          <Spacer s="xl" />
          {props.children}
        </FullScreenLayout>
        <Footer />
      </div>
    </MmbApiSectionProvider>
  );
};
